import { EJExitWheelBonusState } from "states/wheelbonus/ej-exit-wheel-bonus-state";
import { BlastworksClientEvent } from "../ClientController";

export class SocialExitWheelBonusState extends EJExitWheelBonusState {
    public complete(): void {
        this.stateMachine.dispatchClientEvent(BlastworksClientEvent.BONUS_COMPLETE);
        super.complete();
    }
}